<template>
  <Container back_ground_color='items-center h-full max-w-4xl '>
      <Card max_width="max-w-5xl" :title="'Personal Information'" :service_type="membership_type" >
          <div class="w-full flex flex-col p-4 space-y-2">
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2 " flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <TextField nopaste uppercase ref="lname" required :id="'last_name'" type="text" :placeholder="lang('last.name.textfield')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <TextField nopaste uppercase ref="fname" required :id="'first_name'" type="text" :placeholder="lang('first.name.textfield')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <TextField nopaste uppercase ref="mname" :id="'middle_name'" type="text" :placeholder="lang('middle.name.textfield')" @changed="update"/>
              <TextField nopaste nospecial nonumbers uppercase :max_length="4" :id="'suffix'" class=" sm:max-w-xxs md:max-w-xxs xs:w-full" type="text" :placeholder="lang('Suffix')" @changed="update"/>
            </Container>
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2" flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <DropDown taggable required @cleared="cleared" clearable @clicked="getReference"  :id="'branch_of_service'" notSorted ref="branch_of_service" :items="branch_of_service_options" :placeholder="lang('branch.of.service')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <DropDown taggable clearable @clicked="getReference" :required="rank_required" notSorted :disabled="rank_disabled" ref="rank_ref" :id="'rank'" :items="rank_options" type="text" class="md:max-w-xs" :placeholder="lang('rank.textfield')" @changed="update"/>
            </Container>
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2" flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <!-- special_function -->
              <TextField :required="branch_of_service == 'DEP'" @loading="loading" @done="done"  nopaste :max_length="max_length" :minimum_length="minimum_length"  :disable="!sponsor_enabled" uppercase ref="sponsor_nr" :id="'sponsor_nr'" type="text" :placeholder="lang('Sponsor Account/Serial No.')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <TextField :required="branch_of_service == 'DEP'" nopaste :disable="!sponsor_enabled" uppercase ref="sponsor_name" :id="'sponsor_name'" type="text" :placeholder="lang('Sponsor Name e.g (Papsi D. Kalabaw)')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
            </Container> 
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2" flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <TextField :disable="branch_of_service == 'DEP'" :required="branch_of_service != 'DEP'" :max_length="max_length" :minimum_length="minimum_length" nopaste nospecial uppercase ref="serial" :id="'afp_serial'" type="text" :placeholder="lang('afp.serial.number')" @changed="update"/>
              <DropDown :disabled="branch_of_service == 'DEP'" :required="branch_of_service != 'DEP'" @clicked="getReference" ref="employee_status" :id="'employee_status'" class="md:max-w-xs " :items="employment_status_options" :placeholder="lang('employee.status')" @changed="update"/>
            </Container>
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2" flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <DatePicker ref="bdate" required :id="'birth_date'" class="md:max-w-xs" type="text" :placeholder="lang('birth.date.textfield')" componentId="birth_date"  @changed="update"/>
              <TextField nopaste nospecial show_time nonumbers uppercase ref="bplace" required :id="'birth_place'" type="text" :placeholder="lang('place.of.birth')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
            </Container> 
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2" flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <!-- @hasError="hasErrorsField" @clearError="clearErrorFields" -->
              <DropDown @clicked="getReference" ref="gender" required  :id="'gender'" :items="gender_options" :placeholder="lang('gender')"  @changed="update"/>
              <DropDown @clicked="getReference" submittedValue="FILIPINO" taggable ref="citizenship" required :id="'citizenship'" :items="citizenship_options" :placeholder="lang('Citizenship')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <DropDown @clicked="getReference" ref="cstatus" required  :id="'civil_status'" :items="civil_status_options" :placeholder="lang('civil.status')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
            </Container> 
            <TextField nopaste nospecial ref="tin" :required="required_tin" :id="'tin'" type="text" :placeholder="lang('tin')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
            <Container class="h-fit space-x-1 xs:space-x-0 xs:space-y-2" flex_direction='flex-row xs:flex-col' back_ground_color="transparent">
              <TextField :max_length="8" nopaste nospecial ref="sss" :id="'sss'" type="number" :placeholder="lang('SSS No.')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <TextField :max_length="7" nopaste nospecial ref="gsis" :id="'gsis'" type="number" :placeholder="lang('GSIS No.')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
            </Container>
              <TextField nopaste nospecial :max_length="9" ref="mobile" required :id="'mobile'" type='mobile' :placeholder="lang('Mobile No. e.g (927*****) ')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
              <TextField nopaste ref="email"  required :id="'email'" type="text" :placeholder="lang('email')" @hasError="hasErrorsField" @clearError="clearErrorFields" @changed="update"/>
          </div>
      </Card>
  </Container>
</template>
<script>
import { defineComponent } from 'vue';
import Container from '@/components/sections/ContainerView.vue';
import Card from '@/components/controls/CardView.vue';
import TextField from '@/components/controls/TextBoxField.vue';
import DatePicker from '@/components/controls/DatePicker.vue';
import DropDown from '@/components/controls/DropDownControl.vue';
import mixin from "@/mixin";

export default defineComponent({
  components:{
    Container,
    Card,
    TextField,
    DatePicker,
    DropDown
  },
  props:{
    id:{
      type:String,
      required:true,
    }
  },
  data(){
    return {
      first_name:null,
      citizenship_options:["Afghan","Albanian","Algerian","American","Andorran","Angolan","Anguillan","Argentine","Armenian","Australian","Austrian","Azerbaijani","Bahamian","Bahraini","Bangladeshi","Barbadian","Belarusian","Belgian","Belizean","Beninese","Bermudian","Bhutanese","Bolivian","Botswanan","Brazilian","British","British Virgin Islander","Bruneian","Bulgarian","Burkinan","Burmese","Burundian","Cambodian","Cameroonian","Canadian","Cape Verdean","Cayman Islander","Central African","Chadian","Chilean","Chinese","Citizen of Antigua and Barbuda","Citizen of Bosnia and Herzegovina","Citizen of Guinea-Bissau","Citizen of Kiribati","Citizen of Seychelles","Citizen of the Dominican Republic","Citizen of Vanuatu","Colombian","Comoran","Congolese (Congo)","Congolese (DRC)","Cook Islander","Costa Rican","Croatian","Cuban","Cymraes","Cymro","Cypriot","Czech","Danish","Djiboutian","Dominican","Dutch","East Timorese","Ecuadorean","Egyptian","Emirati","English","Equatorial Guinean","Eritrean","Estonian","Ethiopian","Faroese","Fijian","Filipino","Finnish","French","Gabonese","Gambian","Georgian","German","Ghanaian","Gibraltarian","Greek","Greenlandic","Grenadian","Guamanian","Guatemalan","Guinean","Guyanese","Haitian","Honduran","Hong Konger","Hungarian","Icelandic","Indian","Indonesian","Iranian","Iraqi","Irish","Israeli","Italian","Ivorian","Jamaican","Japanese","Jordanian","Kazakh","Kenyan","Kittitian","Kosovan","Kuwaiti","Kyrgyz","Lao","Latvian","Lebanese","Liberian","Libyan","Liechtenstein citizen","Lithuanian","Luxembourger","Macanese","Macedonian","Malagasy","Malawian","Malaysian","Maldivian","Malian","Maltese","Marshallese","Martiniquais","Mauritanian","Mauritian","Mexican","Micronesian","Moldovan","Monegasque","Mongolian","Montenegrin","Montserratian","Moroccan","Mosotho","Mozambican","Namibian","Nauruan","Nepalese","New Zealander","Nicaraguan","Nigerian","Nigerien","Niuean","North Korean","Northern Irish","Norwegian","Omani","Pakistani","Palauan","Palestinian","Panamanian","Papua New Guinean","Paraguayan","Peruvian","Pitcairn Islander","Polish","Portuguese","Prydeinig","Puerto Rican","Qatari","Romanian","Russian","Rwandan","Salvadorean","Sammarinese","Samoan","Sao Tomean","Saudi Arabian","Scottish","Senegalese","Serbian","Sierra Leonean","Singaporean","Slovak","Slovenian","Solomon Islander","Somali","South African","South Korean","South Sudanese","Spanish","Sri Lankan","St Helenian","St Lucian","Stateless","Sudanese","Surinamese","Swazi","Swedish","Swiss","Syrian","Taiwanese","Tajik","Tanzanian","Thai","Togolese","Tongan","Trinidadian","Tristanian","Tunisian","Turkish","Turkmen","Turks and Caicos Islander","Tuvaluan","Ugandan","Ukrainian","Uruguayan","Uzbek","Vatican citizen","Venezuelan","Vietnamese","Vincentian","Wallisian","Welsh","Yemeni","Zambian","Zimbabwean"],
      branch_of_service_options:[],
      gender_options:[],
      civil_status_options:[],
      employment_status_options:[],
      rank_options:[],
      rank_disabled:true,
      sponsor_enabled:false,
      membership_type:null,
      sss:'',
      gsis:'',
      max_length:6,
      required_tin:true,
      last_name:null,
      middle_name:"",
      rank:null,
      birth_date:null,
      birth_place:null,
      gender:null,
      citizenship:null,
      civil_status:null,
      afp_serial:null,
      tin:null,
      branch_of_service:null,
      employee_status:null,
      mobile:null,
      email:null,
      suffix:null,
      errors_log:[],
      rank_id:null,
      sponsor_nr:null,
      sponsor_name:null,
      rank_required:false,
      minimum_length:5,
    }
  },
  methods:{
    loading(){
      this.$emit('loading');
    },
    done(){
      this.$emit('done');
    },
    getReference(e){
    let that = this;
    let store = that.$store;
    let state = store.state;
    let references = state.references;
    let new_arr = [];
    
    if(e.key == 'branch_of_service'){
        that.branch_of_service_options = [];
        for(let x = 0 ; x<references.branch_of_service.length;x++) {
          that.branch_of_service_options.push(references.branch_of_service[x].label);
        }
    } 
     if(e.key == 'employee_status'){
        that.employment_status_options = [];
          
        for(let x = 0 ; x<references.employment_status_options.length;x++) {
          that.employment_status_options.push(references.employment_status_options[x].name);
        }
    } 
    if(e.key =='gender'){
      that.gender_options = [];
        for(let x = 0 ; x<references.gender.length;x++) {
          that.gender_options.push(references.gender[x].label);
        }
    }
    if(e.key =='civil_status'){
       that.civil_status_options = [];
        for(let x = 0 ; x<references.civil_status.length;x++) {
          that.civil_status_options.push(references.civil_status[x].label);
        }
    }
    if(e.key == 'rank'){
          if(references.ranks[that.branch_of_service]) {
            that.rank_options = [];
              new_arr = references.ranks[that.branch_of_service];
              for(let i = 0; i<new_arr.length;i++) {
                that.rank_options.push(new_arr[i].prefix);
              }
          }
    }
    },
    cleared(){
      this.rank_options = [];
      this.rank_disabled = true;
    },
    update(e) {
          let key = e.key;
          let that = this;
          let store = that.$store;
          let state = store.state;
          let references = state.references;
          let member = state.membership_details;
          that.error_message = false;
          that[key] = e.value;
          // console.log(that.birth_date);
          if(key == 'mobile'){
            that.$emit('numberchange');
          }
          if(key =='afp_serial') {
            if(/^[0-9 a-np-z]$/.test(e.value)){
              that.minimum_length = 5;
              that.max_length = 6;
            }
            if(/^(O-)$/.test(e.value)){
              that.minimum_length =6;
              that.max_length = 6;
            }
           
            that.$refs.serial.checkLength();
            
            state.membership_details.afp_serial_number = that.afp_serial;
            state.membership_details.max_length = that.max_length + 1;
            state.membership_details.minimum_length = that.minimum_length + 1;
          }
          if(key == 'email'){
            that.$emit('emailchange');
          }
            
          if(key == 'tin'){
            that.$emit('tinchange');
          }
          if(key=="sponsor_nr") {
            that.$refs.sponsor_nr.checkLength();
          }
          if(key =='branch_of_service') {
                if(that.rank_id){
                    that.$refs.rank_ref.clearValue();
                }
                
                member.sponsor_nr = null;
                member.sponsor_name = null;
                member.rank = null;
                // console.log(that.$refs.sponsor_number.curr_val);
                that.$refs.sponsor_nr.clearText();
                that.$refs.sponsor_name.clearText();
                that.$refs.serial.clearText();
                that.$refs.employee_status.clearValue();
                // that.rank_id =null;
                // 
                that.afp_serial=null;
             for(let checker = 0 ; checker<references.branch_of_service.length;checker++){
                  if(e.value == (references.branch_of_service[checker].label).toString().toUpperCase()){
                    that.branch_of_service = references.branch_of_service[checker].code;
                    state.membership_details.branch_of_service_text = e.value;
                    that.rank_options = [];
                  }
            }

            if(that.branch_of_service == "DEP") {
              // console.log(state.membership_details.rank);
              state.membership_details.rank = null;
              //  console.log(state.membership_details.rank);
              that.rank_required = false;
              that.required_tin = true;
              that.afp_serial="??????";
              that.sponsor_enabled =true;
              that.membership_type = "DEP";
              state.membership_details.mem_type =  "DEP";
            }else{
              that.required_tin = true;
              that.sponsor_enabled =false;
            }
            if(that.branch_of_service == "PA"){
              that.membership_type = "REGULAR";
              state.membership_details.mem_type =  "REGULAR";
            }
          
            if(that.branch_of_service == "CIV"  || that.branch_of_service == "PMC" || that.branch_of_service == "PAF" || that.branch_of_service == "PN"){
              that.membership_type = "ASSOCIATE";
              state.membership_details.mem_type =  "ASSOCIATE";
            }
            if(that.branch_of_service != "CIV" && that.branch_of_service != "DEP"){
               that.rank_disabled = false;
               that.rank_required = true;
               state.membership_details.rank_required = true;
            }else{
              that.rank_disabled = true;
              that.rank_required = false;
              state.membership_details.rank_required = false;
            }
          }
          if(key == 'rank'){
            if(e.value !=""){
              for(let i = 0; i < references.ranks[state.membership_details.branch_of_service].length; i++){
                if(e.value == references.ranks[state.membership_details.branch_of_service][i].prefix){
                    that.rank_id = references.ranks[state.membership_details.branch_of_service][i].id;
                    state.membership_details.ranks_text = references.ranks[state.membership_details.branch_of_service][i].prefix;
                }
              }
            }
          }
          if(key =='gender') {
            for(let checker = 0 ; checker<references.gender.length;checker++){
                  if(e.value == (references.gender[checker].label).toString().toUpperCase()){
                    that.gender = references.gender[checker].code;
                    state.membership_details.gender_text = e.value;
                  }
            }
          }
          if(key =='civil_status') {
            for(let checker = 0 ; checker<references.civil_status.length;checker++){
                  if(e.value == (references.civil_status[checker].label).toString().toUpperCase()){
                      that.civil_status = references.civil_status[checker].code;
                      state.membership_details.civil_status_text=e.value;
                  }
            }
          }
           if(key =='employee_status') {
            if(that.branch_of_service == "PA" && that.employee_status == 'RETIRED'){
              that.membership_type = "ASSOCIATE";
              state.membership_details.mem_type =  "ASSOCIATE";
            }else if(that.branch_of_service == "PA" && that.employee_status == 'ACTIVE'){
              state.membership_details.mem_type = "REGULAR";
              that.membership_type = "REGULAR";
            }
            for(let checker = 0 ; checker<references.employment_status_options.length;checker++){
                  if(e.value == (references.employment_status_options[checker].name).toString().toUpperCase()){
                      that.employee_status = references.employment_status_options[checker].code;
                      state.membership_details.employee_status_text=e.value;
                  }
            }
          }
          
          
          state.membership_details.first_name = that.first_name;
          state.membership_details.last_name = that.last_name;
          state.membership_details.rank = that.rank_id;
          state.membership_details.middle_name = that.middle_name;
          state.membership_details.birth_date = that.birth_date;
          state.membership_details.place_of_birth =  that.birth_place;
          state.membership_details.gender = that.gender;
          state.membership_details.civil_status = that.civil_status;
          state.membership_details.tin = that.tin;
          state.membership_details.branch_of_service = that.branch_of_service;
          state.membership_details.employee_status = that.employee_status;
          state.membership_details.mobile = "+63"+that.mobile;
          state.membership_details.suffix = that.suffix;
          state.membership_details.email = that.email;
          state.membership_details.citizenship = that.citizenship;
          state.membership_details.sss_number = that.sss;
          state.membership_details.gsis_number = that.gsis;
          state.membership_details.sponsor_nr = that.sponsor_nr;
          state.membership_details.sponsor_name = that.sponsor_name;
        },
      checkLengthSSS(){
        let ref = this.$refs;
        ref.sss.checkLength();
      },
      checkLengthGSIS(){
        let ref = this.$refs;
        ref.gsis.checkLength();
      },
      checkLength(){
        let ref = this.$refs;
        let that = this;
        let store = that.$store;
        let state = store.state.membership_details;

        if(state.sss_number != ''){
          ref.sss.checkLength();
        }
        if(state.gsis_number != ''){
          ref.gsis.checkLength();
        }
      },
      checkFields() {
        let that = this;
        let ref = that.$refs;
        let store = that.$store.state.membership_details;

        ref.lname.checkEmpty();
        ref.fname.checkEmpty();
        ref.bplace.checkEmpty();
        ref.gender.checkEmpty();
        ref.cstatus.checkEmpty();
        ref.mobile.checkEmpty();
        ref.email.checkEmpty();
        ref.bdate.checkEmpty();
        ref.mname.checkEmpty();
        ref.serial.checkEmpty();
        ref.mobile.checkValidNumber();

        if(store.branch_of_service != "DEP"){
          ref.rank_ref.checkEmpty();
          ref.tin.checkEmpty();
          ref.employee_status.checkEmpty();
        }
        if(store.branch_of_service !="CIV"){
          ref.rank_ref.checkEmpty();
        }
        if(store.branch_of_service=="DEP"){
          ref.sponsor_nr.checkEmpty();
          ref.sponsor_name.checkEmpty();
        }
        ref.branch_of_service.checkEmpty();
        ref.email.validateEmail();
        ref.mobile.checkDuplicate();
        ref.email.checkDuplicate();
        if(store.branch_of_service!="DEP"){
            ref.tin.checkDuplicate();
        }
        
      },
      hasErrorsField(e){
        this.errors_log.push(e);
        this.hasError();
      },
      hasError() {
       this.$emit("hasError",this.id);

      },
      clearErrorFields(id) {
        for(let i = 0; i<this.errors_log.length ; i++ )
        {
          if(id == this.errors_log[i]) {
             this.errors_log.splice(i,1)
          }
        }
        if(this.errors_log.length == 0){
          this.clearError();
        }
      },
      clearError() {
        this.$emit("clearError",this.id);
      }
  },
   mixins: [
    mixin,
  ],
})
</script>
<style scoped>
.max-width-suffix{
  max-width: 80px;
}
</style>
